var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormPanel',{attrs:{"headline":"Create Layout","errors":_vm.errors,"layout-categories":_vm.layoutCategories},on:{"submit":_vm.submit}})
}
var staticRenderFns = []

export { render, staticRenderFns }